<template>
  <div>
    <div class="font-weight-bold grey--text text--darken-1">Adicione uma capa (Thumbnail)</div>
    <v-card outlined :disabled="!isActivePlan" flat class="mt-3">
      <div style="position: relative; cursor: pointer;"
        @click="dialogImage = true"
        @mouseover="hover = true"
        @mouseleave="hover = false"
      >
        <v-icon v-if="hover" color="white" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); z-index: 99;" x-large>mdi-image-edit</v-icon>
        <div class="black">
          <v-img
            :style="hover ? 'opacity: .6; transition: opacity .5s ease-out;' : ''"
            style="height: 200px;"
            :src="form.thumbnail_image || '/img/thumb-zaper.svg'"
          ></v-img>
        </div>
      </div>
      <div class="pa-4">
        <v-text-field
          label="Adicione um título"
          v-model="form.thumbnail_title"
          outlined
          hide-details
          dense
        ></v-text-field>
        <v-textarea 
          rows="2"
          class="mt-4"
          label="Adicione uma descrição"
          v-model="form.thumbnail_description"
          outlined
          hide-details
          dense
        ></v-textarea>
      </div>
    </v-card>

    <zp-dialog-image v-model="dialogImage" @save="updateImage"></zp-dialog-image>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import ZpDialogImage from '@/components/DialogImage'

export default {
  props: ['form'],
  components: {
    ZpDialogImage
  },
  data () {
    return {
      dialogImage: false,
      hover: false
    }
  },
  computed: {
    ...mapGetters({
      project: 'projects/getSelected'
    }),
    ...mapState({
      user: state => state.auth.user
    }),
    isActivePlan () {
      return moment(this.user.active_plan_at || 0).valueOf() > Date.now() || this.project.user_id !== this.user.id
    }
  },
  methods: {
    updateImage (url) {
      this.form.thumbnail_image = url
    }
  }
}
</script>

<style lang="scss" scoped>

</style>